








// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBasePiscine from '@/components/administration/piscine/edit/EditBasePiscine.vue'
import * as rules from '@/utils/validationRules'
import { toStringDictionary } from '@/utils/groupBy'
import { getDefaultAloPiscine } from '@/models/alo/AloPiscine'
import { AloPiscine } from '@/models/alo/AloPiscine'

@Component({
  name: 'EditContent',    
  components:{EditBasePiscine}
})
export default class EditContent extends Vue {
      
  private piscine:AloPiscine = getDefaultAloPiscine()

  edit(item:AloPiscine) {    
    this.piscine = (this.$refs.baseEdit as EditBasePiscine).edit(item)    
  }
  
 
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }  
      
}
